"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Functions = require("../core/Functions");

var _UICheckbox = _interopRequireDefault(require("../input/UICheckbox"));

var _UIRadioInput = _interopRequireDefault(require("../input/UIRadioInput"));

var _underscore = require("../utils/underscore");

var _ActiveProvider = _interopRequireDefault(require("../providers/ActiveProvider"));

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _decorators = require("../utils/propTypes/decorators");

var UISelectableBox = _react.default.createClass({
  displayName: "UISelectableBox",
  propTypes: {
    active: (0, _decorators.hidden)(_react.PropTypes.bool),
    'aria-checked': _react.PropTypes.bool,
    block: _react.PropTypes.bool,
    children: _react.PropTypes.node.isRequired,
    disabled: _react.PropTypes.bool.isRequired,
    flush: _react.PropTypes.bool,
    height: _react.PropTypes.number,
    hovered: (0, _decorators.hidden)(_react.PropTypes.bool),
    innerClassName: _react.PropTypes.string,
    name: _react.PropTypes.string,
    onSelectedChange: _react.PropTypes.func,
    padded: _react.PropTypes.bool,
    readOnly: _react.PropTypes.bool,
    selected: _react.PropTypes.bool,
    selectionMarkLocation: _react.PropTypes.oneOf(['left', 'top-right']),
    type: _react.PropTypes.oneOf(['default', 'checkbox', 'radio']).isRequired,
    width: _react.PropTypes.number
  },
  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false,
      padded: true,
      readOnly: false,
      selected: false,
      type: 'default'
    };
  },
  handleClick: function handleClick(evt) {
    var _this$props = this.props,
        type = _this$props.type,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly;

    if (disabled || readOnly) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }

    if (type !== 'radio') {
      this.props.onSelectedChange((0, _SyntheticEvent.default)(!this.props.selected));
    }

    (0, _Functions.callIfPossible)(this.props.onClick);
  },
  handleKeyPress: function handleKeyPress(evt) {
    if (evt.target.type === 'checkbox') return;
    var key = evt.key; // treat enter or space key like a click event

    if (key === 'Enter' || key === ' ') {
      evt.preventDefault();
      this.handleClick();
    }
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        __active = _this$props2.active,
        block = _this$props2.block,
        children = _this$props2.children,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        flush = _this$props2.flush,
        height = _this$props2.height,
        __hovered = _this$props2.hovered,
        innerClassName = _this$props2.innerClassName,
        name = _this$props2.name,
        __onClick = _this$props2.onClick,
        __onSelectedChange = _this$props2.onSelectedChange,
        padded = _this$props2.padded,
        readOnly = _this$props2.readOnly,
        selected = _this$props2.selected,
        selectionMarkLocation = _this$props2.selectionMarkLocation,
        tabIndex = _this$props2.tabIndex,
        type = _this$props2.type,
        width = _this$props2.width,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["active", "block", "children", "className", "disabled", "flush", "height", "hovered", "innerClassName", "name", "onClick", "onSelectedChange", "padded", "readOnly", "selected", "selectionMarkLocation", "tabIndex", "type", "width"]);
    this._id = this._id || (0, _underscore.uniqueId)('bsb-');
    return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
      return _react.default.createElement(_ActiveProvider.default, _this.props, function (activeProviderProps) {
        var active = activeProviderProps.active,
            activeProviderRestProps = (0, _objectWithoutProperties2.default)(activeProviderProps, ["active"]);
        var hovered = hoverProviderProps.hovered,
            hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
        var computedClassName = (0, _classNames.default)('uiButton', 'private-button', 'private-selectable-box', {
          'private-button--active': active,
          'private-selectable-box--selected': selected,
          'private-button--block': block,
          'disabled private-button--disabled': disabled,
          'private-selectable-box--hovered': hovered && !disabled && !readOnly,
          'private-selectable-box--padded': padded,
          'private-selectable-box--flush': flush,
          'private-selectable-box--readonly': readOnly
        }, className);
        var renderedSelectionMark = null;

        if (type !== 'default') {
          var selectionMarkClassname = (0, _classNames.default)('private-selectable-box__selection-mark', {
            'private-selectable-box__selection-mark--left': selectionMarkLocation === 'left',
            'private-selectable-box__selection-mark--top-right': selectionMarkLocation === 'top-right'
          });

          if (type === 'checkbox') {
            renderedSelectionMark = _react.default.createElement("div", {
              className: selectionMarkClassname
            }, _react.default.createElement(_UICheckbox.default, {
              "aria-labelledby": _this._id,
              checked: selected,
              disabled: disabled,
              innerPadding: "none",
              name: name,
              onChange: _this.handleClick,
              onClick: function onClick(e) {
                return e.stopPropagation();
              },
              readOnly: readOnly
            }));
          }

          if (type === 'radio') {
            if (!name) {
              _devLogger.default.warn({
                message: 'UISelectableBox: If type is set to radio you must provide a name',
                key: 'UISelectableBox: no name value'
              });
            }

            renderedSelectionMark = _react.default.createElement("div", {
              className: selectionMarkClassname
            }, _react.default.createElement(_UIRadioInput.default, {
              "aria-labelledby": _this._id,
              checked: selected,
              disabled: disabled,
              name: name,
              onChange: _this.handleClick,
              onClick: function onClick(e) {
                return e.stopPropagation();
              },
              readOnly: readOnly
            }));
          }
        }

        var tabbableByDefault = !disabled && type === 'default';
        var defaultTabIndex = tabbableByDefault ? 0 : null;
        return (// eslint-disable-next-line jsx-a11y/no-static-element-interactions
          _react.default.createElement("div", (0, _extends2.default)({}, rest, activeProviderRestProps, hoverProviderRestProps, {
            "aria-checked": selected,
            "aria-disabled": disabled,
            className: computedClassName,
            onClick: _this.handleClick,
            onKeyPress: _this.handleKeyPress,
            role: type === 'radio' ? 'radio' : 'checkbox',
            tabIndex: typeof tabIndex === 'number' ? tabIndex : defaultTabIndex
          }), renderedSelectionMark, _react.default.createElement("div", {
            className: (0, _classNames.default)('private-selectable-box__inner', innerClassName),
            id: _this._id,
            style: {
              height: height,
              width: width
            }
          }, children))
        );
      });
    });
  }
});

var _default = (0, _Controllable.default)(UISelectableBox, ['selected']);

exports.default = _default;
module.exports = exports.default;